import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// styles
import styles from "./UberEats.module.css";
// components
import Container from "../../components/Container";
import AlertMsg from "../../components/AlertMsg";
import Loader from "../../components/Loader";
import UploadFile from "../../components/UploadFile";
import RestaurantHeader from "../../components/RestaurantHeader";
// utils
import { utils } from "../../lib/utils";
// api
import { importExportFoodoJsonServices } from "../../api/useQueryHooks";
// assets
import { ReactComponent as JsonIcon } from "../../assets/images/json.svg";
import { ReactComponent as CloseIcon } from "../../assets/images/close_red.svg";

const ImportExportFoodMenu = () => {
  const navigate = useNavigate();
  const restaurantId = useParams()?.rest_id;
  const [jsonList, setJsonList] = useState([]);
  const [jsonFile, setJsonFile] = useState(null);
  const [msgAlert, setMsgAlert] = useState({
    open: false,
    message: "",
    msgType: "error",
  });

  const uploadFile = async (data, file) => {
    data["upload"] = true;
    setJsonFile(file);
    setJsonList([data]);
  };

  const uploadError = (err) => {
    setMsgAlert({ open: true, message: err, msgType: "error" });
  };

  const onRemoveFile = (file) => {
    setJsonFile(null);
    setJsonList((prev) => prev.filter((x) => x.id !== file.id));
  };

  const importFoodoMenu = importExportFoodoJsonServices.useImportFoodoJson();
  const uploadJsonFile = async () => {
    if (jsonFile == null) {
      setMsgAlert({
        open: true,
        message: "Upload Json File",
        msgType: "error",
      });
      return;
    }
    const data = await utils.parseJsonFile(jsonFile);
    importFoodoMenu.mutate(
      { restaurantId, data },
      {
        onSuccess: () => {
          setMsgAlert({
            open: true,
            message: "Upload Successfully",
            msgType: "success",
          });
          setJsonFile(null);
          setJsonList([]);
        },
        onError: (error) => {
          setMsgAlert({
            open: true,
            message: error?.message,
            msgType: "error",
          });
        },
      }
    );
  };

  const exportFoodoMenu = importExportFoodoJsonServices.useExportFoodoJson();
  const handleExportFoodoMenu = () => {
    exportFoodoMenu.mutate(restaurantId, {
      onSuccess: (data) => {
        utils.downloadJsonFile(data?.data, "menu.json");
        setMsgAlert({
          open: true,
          message: "Download Successfully",
          msgType: "success",
        });
      },
      onError: (error) => {
        setMsgAlert({
          open: true,
          message: error?.message,
          msgType: "error",
        });
      },
    });
  };

  return (
    <Container
      page={"restaurants"}
      searchVal={""}
      onSearch={() => null}
      searchLabel=""
    >
      {importFoodoMenu?.isPending ? (
        <Loader height={{ height: window.innerHeight - 150 }} />
      ) : (
        <Grid container item xs={12}>
          <Grid item xs={12} mb={2}>
            <RestaurantHeader
              title={`Upload/Download Menu - Foodo`}
              onBackBtnClick={() =>
                navigate(`/restaurant/${restaurantId}/manage_menu`)
              }
            />
          </Grid>
          <Grid item xs={12} className={styles.mainView} p={3}>
            <Grid item xs={12} md={8}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                item
                xs={12}
              >
                <Grid item xs={12} md={5.8}>
                  <UploadFile
                    page={"foodomenu"}
                    uploadText={"Drag and Drop Your JSON file Here"}
                    imageLoading={false}
                    maxFiles={3}
                    uploadHeight={"240px"}
                    accept={{ "application/json": [".json"] }}
                    uploadError={uploadError}
                    uploadFile={uploadFile}
                  />
                  <Typography my={2} className={styles.noteText}>
                    Note: Upload JSON file
                  </Typography>
                  <Box
                    mt={2}
                    className={styles.addBtnView}
                    onClick={() => uploadJsonFile()}
                  >
                    <Typography className={styles.addBtnText}>
                      Upload
                    </Typography>
                  </Box>
                  <Box
                    mt={2}
                    className={styles.addBtnView}
                    onClick={() => handleExportFoodoMenu()}
                  >
                    <Typography className={styles.addBtnText}>
                      Download Menu
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  container
                  direction="column"
                  item
                  xs={12}
                  md={5.8}
                  sx={{
                    marginTop: { xs: 5, md: 2 },
                    paddingLeft: 0,
                    paddingRight: 0,
                  }}
                >
                  {jsonList.map((item, index) => {
                    return (
                      <Box key={index} className={styles.fileListView} mb={2}>
                        <JsonIcon width={40} height={40} />
                        <Typography className={styles.fileNameText} mx={1}>
                          {item.name}
                        </Typography>
                        <Box
                          style={{ cursor: "pointer" }}
                          onClick={() => onRemoveFile(item)}
                        >
                          <CloseIcon width={20} height={20} />
                        </Box>
                      </Box>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <AlertMsg
            msgAlert={msgAlert}
            onCloseAlertMsg={() =>
              setMsgAlert({ open: false, message: "", msgType: "error" })
            }
          />
        </Grid>
      )}
    </Container>
  );
};

export default ImportExportFoodMenu;
